<ng-content *ngIf="!loading; else loader"></ng-content>

<ng-template #loader>
	<div class="row mx-0 p-1 text-center">
		<div class="col-12">
			<svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
				<circle class="internal-circle" cx="50" cy="50" r="25" />
				<circle class="external-circle" cx="50" cy="50" r="40" />
			</svg>
		</div>
	</div>
</ng-template>
